module.exports = __webpack_public_path__ + "img/xbz.61c35091.png";